import { render } from "./studentSpecialList.vue?vue&type=template&id=be30ce98&scoped=true"
import script from "./studentSpecialList.vue?vue&type=script&lang=js"
export * from "./studentSpecialList.vue?vue&type=script&lang=js"

import "./studentSpecialList.vue?vue&type=style&index=0&id=be30ce98&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be30ce98"]])

export default __exports__